export default __webpack_public_path__ + "static/step2-dc7b657426436e8cbf30b74241878cf1.png";